var map = {
	"./033-bm.webp": 1229,
	"./033-cn.webp": 1230,
	"./033.webp": 1231,
	"./13-bm.webp": 1232,
	"./13-cn.webp": 1233,
	"./13.webp": 1234,
	"./3-bm.webp": 1235,
	"./3-cn.webp": 1236,
	"./3.webp": 1237,
	"./angpao-bg-mobile.jpg": 1238,
	"./angpao-bg.jpg": 1239,
	"./angpao-bm.webp": 1240,
	"./angpao-cn.webp": 1241,
	"./angpao.webp": 1242,
	"./button.png": 1243,
	"./close-eye.png": 1244,
	"./coin-1.png": 1245,
	"./coin.png": 1246,
	"./ketupak-open.png": 1247,
	"./ketupak.png": 1248,
	"./ketupak_ribbon.png": 1249,
	"./rain-1.png": 1250,
	"./rain-2.png": 1251,
	"./rain-3.png": 1252,
	"./raya-bg-mobile.png": 1253,
	"./raya-bg.png": 1254,
	"./shine.png": 1255,
	"./star-1.png": 1256,
	"./star-2.png": 1257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;